<template>
  <div class="flex sp-flex-direction-column">
    <div
      v-if="
        transaction.not_seller_responded_yet ||
        isCancelableRefuse ||
        isEditableApplyComment
      "
      class="flex items-center justify-center mr-2 body-sm leading-normal text-gray-62"
    >
      応募期限：{{
        utils.formatDatetime(transaction.send_answer_expired_at)
      }}（{{ utils.displayExpired(transaction.send_answer_expired_at) }}）
    </div>
    <div
      class="flex items-center body-sm px-4 font-semibold rounded justify-center"
      style="height: 1.75rem; min-width: 176px"
      :class="{
        'text-coral-main': selectStatus === FILTER_NOT_SELLER_RESPONDED_YET,
        'text-green':
          selectStatus === FILTER_SELLER_RESPONDED_OK ||
          selectStatus === FILTER_INTRODUCED,
      }"
      :style="{
        'background-color': backgroundColor,
      }"
    >
      {{ displayName }}
    </div>
  </div>
</template>

<script>
import {
  FILTER_ADMIN_RESPONDED_FAIL,
  FILTER_ALL,
  FILTER_CONTRACT_NG,
  FILTER_EXPIRED,
  FILTER_INTRODUCED,
  FILTER_NOT_SELLER_RESPONDED_YET,
  FILTER_REFUSED,
  FILTER_SELLER_RESPONDED_OK,
  FILTER_TYPES,
  attachTransactionStatusForNewPlan,
} from '@/utils/transctionSelectionStatus';
import utils from '@/utils/utils';

export default {
  props: {
    transaction: {
      required: true,
    },
    isCancelableRefuse: {
      type: Boolean,
    },
    isEditableApplyComment: {
      type: Boolean,
    },
  },
  setup(props) {
    let statusParams = attachTransactionStatusForNewPlan(props.transaction);

    return {
      ...statusParams,
      FILTER_TYPES,
      FILTER_ALL,
      FILTER_NOT_SELLER_RESPONDED_YET,
      FILTER_SELLER_RESPONDED_OK,
      FILTER_ADMIN_RESPONDED_FAIL,
      FILTER_REFUSED,
      FILTER_EXPIRED,
      FILTER_INTRODUCED,
      FILTER_CONTRACT_NG,
      utils,
    };
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 640px) {
  .sp-flex-direction-column {
    flex-direction: column;
  }
}
</style>
